import React from 'react';

const Incidents = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="medical_report" data-name="medical report">
          <path d="M25.71,6.29l-4-4A1,1,0,0,0,21,2H7A1,1,0,0,0,6,3v8a1,1,0,0,0,2,0V4H19V8a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2H21V4.41l3,3V28H21a1,1,0,0,0,0,2h4a1,1,0,0,0,1-1V7A1,1,0,0,0,25.71,6.29Z" />
          <path d="M18,28H8V14a1,1,0,0,0-2,0V29a1,1,0,0,0,1,1H18a1,1,0,0,0,0-2Z" />
          <path d="M12,6a1,1,0,0,0-1,1V8H10a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V10h1a1,1,0,0,0,0-2H13V7A1,1,0,0,0,12,6Z" />
          <path d="M10,16h8a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z" />
          <path d="M10,20H21a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z" />
          <path d="M10,24H21a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z" />
        </g>
      </svg>
    </div>
  );
}
export default Incidents;
